import { IoFilter } from "react-icons/io5";
import { FaWrench } from "react-icons/fa6";
import { useCompanyStore } from "@/common/states/store/Company";
import { Filter } from "./Filter";
import { useDashboardMaintenances } from "@/common/states/store/slices/dashboardSlice";
import { useGetAllMaintenances } from "@/common/hooks";
import { format, parseISO } from "date-fns";
interface DashboardHeaderProps {
  onFullScreen: () => void;
}

export function Header({
  onFullScreen
}: DashboardHeaderProps) {
  const company = useCompanyStore(state => state.company)
  const { openModalFilter, closeModalFilter,  modals, filters } = useDashboardMaintenances()
  const handleOpenFilters = () => openModalFilter()
  const { refetch } = useGetAllMaintenances();

  return (
    <div className="p-4 sm:p-6 bg-white pt-4 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-6 sm:mb-8 pb-4 border-b border-gray-200 ">
      <div className="flex flex-col justify-center items-start">
        <h1 className="text-xl sm:text-2xl font-semibold flex items-center gap-2 text-black">
          <FaWrench onClick={onFullScreen} className="text-locavibe"/>
          <span className="leading-tight">
            Dashboard Manutenções - 
            <span className="block sm:inline sm:ml-1 text-gray-600 text-base sm:text-xl">
              {company?._id === "*" ? "Operação Brasil" : company?.companyName }
            </span>
          </span>
        </h1>
        <span>
          Periodo {format(parseISO(filters.dateFilters.startDate), "dd/MM/yyyy")} à {" "} 
          {format(parseISO(filters.dateFilters.endDate), "dd/MM/yyyy")}
        </span>
      </div>

      <div className="flex items-center gap-3">
        <button
          onClick={handleOpenFilters}
          className="bg-white border border-gray-300 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-50 hover:border-gray-400 transition-all flex items-center gap-2 shadow-sm"
        >
          <IoFilter className="text-lg" />
          <span className="font-medium">Filtrar</span>
        </button>
      </div>
      <Filter isOpen={modals.filters} onClose={closeModalFilter}  onApply={refetch}/>
    </div>
  );
}
